import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_CLIENT_INFO } from "config/connString";
import useAxios from "utils/useAxios";

const clientLookUp = createAsyncThunk("client/client-lookup", async (data) => {
  try {
    const api = useAxios();
    const config = {
      params: {
        search: data?.search,
        pageSize: 0,
        pageNumber: 1,
        sortField: "Id",
      },
    };
    const response = await api.get(URL_CLIENT_INFO + "-lookup", config);
    return response.data;
  } catch (error) {
    return error;
  }
});

export { clientLookUp };
